export default "__VITE_ASSET__46d0aa4e__"